import { pdsTv } from '@nestle-npus-nbm/pds-ui';

export interface IThemeVariant {
  level?: 1 | 2 | 3;
  isOnlyText?: boolean;
  isOnlyBg?: boolean;
}

/**
 * Returns and exposes the default theme variant themes for pdsTv,
 *
 * You can specify a level intended for cards which will darken the background by 1 level. In the case of dark theme it lightens the background.
 */
export const themeVariant = (themeObj?: IThemeVariant) => {
  const level = themeObj?.level || 1;
  const isOnlyText = themeObj?.isOnlyText;
  const isOnlyBg = themeObj?.isOnlyBg;

  if (isOnlyText) {
    return {
      dark: ['pds-text-neutral-text'],
      light: ['pds-text-surface-text'],
      neutral: ['pds-text-surface-text'],
    };
  }

  if (level === 2) {
    return {
      dark: ['pds-bg-neutral-layer', !isOnlyBg && 'pds-text-neutral-text'].filter(Boolean),
      light: ['pds-bg-surface-layer', !isOnlyBg && 'pds-text-surface-text'].filter(Boolean),
      neutral: ['pds-bg-surface-line', !isOnlyBg && 'pds-text-surface-text'].filter(Boolean),
    };
  }

  if (level === 3) {
    return {
      dark: ['pds-bg-neutral-line', !isOnlyBg && 'pds-text-neutral-text'].filter(Boolean),
      light: ['pds-bg-surface-line', !isOnlyBg && 'pds-text-surface-text'].filter(Boolean),
      neutral: ['pds-bg-surface-heavy', !isOnlyBg && 'pds-text-surface-text'].filter(Boolean),
    };
  }

  return {
    dark: ['pds-bg-neutral', !isOnlyBg && 'pds-text-neutral-text'].filter(Boolean),
    light: ['pds-bg-surface', !isOnlyBg && 'pds-text-surface-text'].filter(Boolean),
    neutral: ['pds-bg-surface-layer', !isOnlyBg && 'pds-text-surface-text'].filter(Boolean),
  };
};

export const themeStyles = pdsTv({
  base: '',
  variants: {
    theme: themeVariant(),
  },
  defaultVariants: {
    theme: 'light',
  },
});

// specifically made for icon cards
export const imageMatteTv = pdsTv({
  base: 'pds-rounded',
  variants: {
    theme: {
      light: 'pds-bg-surface-layer',
      dark: 'pds-bg-surface-layer',
      neutral: 'pds-bg-surface',
    },
  },
});
